<template>
  <div id="bodyCon"
       :class="{side:sideIsShow}">
    <div id="sidebar">
      <div class="logoCon">
        <a @click="$goRoute('home')">
          <img class="sideLogo" src="./assets/img/logo.png" alt="我的头像">
          <p class="sideUserName">{{blogInfo.blogName}}</p>
          <p class="sideSubtitle">{{blogInfo.subtitle}}</p>
        </a>
      </div>
      <ul class="sideNav">
        <li class="navList" @click="sideIsShowFn('navList')" v-for="item in navLists"><a
          @click="$goRoute(item.route)">{{item.text}}</a></li>
      </ul>
    </div>
    <div id="sidebar-mask" @click="sideIsShowFn()" v-show="sideIsShow"></div>
    <div id="header">
      <img @click="sideIsShowFn()" class="headerLogo" src="./assets/img/logo.png" alt="">
      <p class="headerUserName">
        <a @click="$goRoute('home')">{{blogInfo.blogName}}</a>
      </p>
    </div>

    <!--<p>这是我的第一个页面</p>-->
    <div id="main">
      <router-view></router-view>
    </div>

  </div>
</template>

<script>
  import {goSnow,isPhone} from './assets/js/utils'
  import {blogsSDK} from './assets/js/blogsSDK'
  //  import { mapActions } from 'vuex'

  export default {
    name: 'app',
    data() {
      return {
        navLists: [
          {
            text: '首页',
            route: 'home'
          },
          {
            text: '归档',
            route: 'archives'
          },
          {
            text: '标签',
            route: 'tags'
          },
          {
            text: '导航',
            route: 'links'
          },
          {
            text: '关于',
            route: 'about'
          }
        ],
        sideIsShow: false,
        blogInfo: {}
      }
    },
    methods: {//方法
      sideIsShowFn: function (val) {
//        console.log(1)
        if (val && !this.sideIsShow) {
          return
        }
        this.sideIsShow = !this.sideIsShow;
      }
    },
    beforeCreate: function () {
      let _that = this;

      //初始化博客信息
      this.$http.get(blogsSDK.serverHost + '/data/blogsInfo.json',
      ).then((response) => {
        this.$store.commit('blogsInfoSet', response.body)
        // this.$store.dispatch('blogsInfoSet', response.body);
        _that.blogInfo = _that.$store.state.blogInfo
      }).catch(function (response) {
        console.log(response)
      });
      //初始化笔记条目
      this.$http.get(blogsSDK.serverHost + '/data/noteList.json',
      ).then((response) => {
        this.$store.commit('noteListSet', response.body)
        // this.$store.dispatch('noteListSet', response.body);
      }).catch(function (response) {
        console.log(response)
      });


    },
    mounted: function () {//挂载到实例上后执行
      // console.log(this)
      console.log(1)
      if (!isPhone()){
        //雪花效果
        // goSnow('bodyCon', blogsSDK.serverHost+'/img/snow/flower.png', 10, 3);
      }
    },
  }
</script>

<style lang="scss">
  @import url(assets/css/reset.css);

  body, html {
    width: 100%;
    height: 100%;
    overflow: hidden;
    font-family: "\5FAE\8F6F\96C5\9ED1", Helvetica, sans-serif;
  }

  #bodyCon {
    background-color: #fdf5d8;
    width: 100%;
    height: 100%;
    /*overflow-y: auto;*/
    -webkit-transition: -webkit-transform .2s cubic-bezier(.4, .01, .165, .99);
    transition: transform .2s cubic-bezier(.4, .01, .165, .99), -webkit-transform .2s cubic-bezier(.4, .01, .165, .99);
    &.side {
      position: relative;
      transform: translate3D(200px, 0, 0);
      -webkit-transform: translate3D(200px, 0, 0);
    }
  }

  #sidebar {
    width: 200px;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: #ababab;
    overflow: auto;
    z-index: 1;
    color: #fff;
    .logoCon {
      text-align: center;
      padding-top: 40px;
      padding-bottom: 10px;
      a {
        cursor: pointer;
      }
      .sideLogo {
        width: 140px;
        height: 140px;
        border-radius: 50%;
      }
      .sideUserName {
        padding: 10px 0;
        font-size: 18px;
      }
      .sideSubtitle {
        font-size: 14px;
      }
    }
    .sideNav {
      /*text-align: center;*/
      .navList {
        height: 45px;
        line-height: 45px;
        cursor: pointer;
        margin-bottom: 10px;
        a {
          display: block;
          position: relative;
          /*width: 100%;*/
          /*height: 100%;*/
          padding-left: 90px;
          &:before {
            content: '';
            position: absolute;
            top: 12px;
            left: 60px;
            width: 25px;
            height: 25px;
            background: url("./assets/img/cssScript.png") no-repeat 0px 0px;
          }
        }

      }
      .navList:nth-child(2) a:before {
        background-position: -25px 0;
      }
      .navList:nth-child(3) a:before {
        background-position: -53px 0;
      }
      .navList:nth-child(4) a:before {
        background-position: -81px 0;
      }
      .navList:nth-child(5) a:before {
        background-position: -110px 0;
      }
    }
  }

  #sidebar-mask {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background-color: rgba(255, 255, 255, 0)
  }

  #header {
    display: none;
    height: 50px;
    line-height: 50px;
    background-color: #202020;
    .headerLogo {
      float: left;
      width: 40px;
      height: 40px;
      border-radius: 40px;
      margin-top: 5px;
      margin-left: 10px;
      cursor: pointer;
    }
    .headerUserName {
      color: #999;
      text-align: center;
      a {
        cursor: pointer;
        font-weight: bold;
      }

    }

  }

  #main {
    height: 100%;
    overflow-y: auto;
    /*padding-right: 20px;*/
    padding-left: 220px;
  }

  @media screen and (max-width: 768px) {
    #sidebar {
      //这里用translate3D会出现元素不一起移动的情况
      /*-webkit-transform: translate3D(-200px, 0, 0);
      -ms-transform: translate3D(-200px, 0, 0);
      transform: translate3D(-200px, 0, 0);*/
      margin-left: -200px;
    }
    #header {
      display: block;
    }
    #main {
      padding-left: 20px;
      .main {
        margin-bottom: 50px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue